export const groupBy = <T>(items: T[], key: string): { [key in string]: T[] } =>
  items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [...(result[item[key]] || []), item],
    }),
    {},
  );
